import { render, staticRenderFns } from "./CreateAccount-2.vue?vue&type=template&id=585d75ea&scoped=true"
import script from "./CreateAccount-2.vue?vue&type=script&lang=js"
export * from "./CreateAccount-2.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount-2.vue?vue&type=style&index=0&id=585d75ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d75ea",
  null
  
)

export default component.exports